<div class="send-email">
  <h1 class="send-email__title typography_size_{{ tuiElementLargeSize }}">
    {{ 'components.sendEmailForm.labels.feedbackForm' | translate }}
  </h1>

  <form class="send-email__form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="send-email__form-fields">
      <tui-input
        maxlength="100"
        formControlName="subject"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [class.tui-skeleton]="isLoading"
        [class.tui-skeleton_text]="isLoading"
      >
        {{ 'components.sendEmailForm.fields.subject' | translate }}
      </tui-input>

      <tui-textarea
        [rows]="10"
        [maxLength]="1000"
        [expandable]="true"
        formControlName="message"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [class.tui-skeleton]="isLoading"
        [class.tui-skeleton_text]="isLoading"
      >
        {{ 'components.sendEmailForm.fields.description' | translate }}
        <span class="tui-required"></span>
      </tui-textarea>

      <tui-input
        formControlName="email"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [class.tui-skeleton]="isLoading"
        [class.tui-skeleton_text]="isLoading"
      >
        {{ 'components.sendEmailForm.fields.sendersEmail' | translate }}
        <span class="tui-required"></span>
      </tui-input>

      <div class="send-email__form-input-files-wrapper">
        <app-input-files
          class="size_{{ tuiElementLargeSize }}"
          style="width: 100%"
          [formControl]="files"
          [maxFileSize]="maxFileSize"
          [multiple]="true"
          [accept]="acceptFileMask"
          [loading]="isLoading"
          (rejectedFiles)="setRejectedFiles($event)"
        ></app-input-files>
      </div>

      <tui-error [formControl]="files" [error]="['maxLength'] | tuiFieldError | async"></tui-error>
    </div>

    <div class="send-email__form-actions">
      <button
        tuiButton
        iconStart="@tui.mail"
        type="submit"
        appearance="primary"
        [loading]="isLoading"
        [size]="tuiElementLargeSize"
      >
        {{ 'common.buttons.send' | translate }}
      </button>
    </div>
  </form>

  <ng-template #successTemplate>
    <p>{{ 'components.sendEmailForm.dialogs.feedbackSuccessFirstLineLabel' | translate }}</p>
    <p>{{ 'components.sendEmailForm.dialogs.feedbackSuccessSecondLineLabel' | translate }}</p>
  </ng-template>
</div>
